import { supabase, isSupabaseConfigured } from './supabase.js';
import { hydrateUserLibrary, clearCloudStateOnSignOut } from './storage.js';

let currentUser = null;
const authListeners = new Set();

export function getUser() { return currentUser; }
export function isAuthenticated() { return currentUser !== null; }

export function onAuthChange(fn) {
  authListeners.add(fn);
  return () => authListeners.delete(fn);
}

function notifyAuthListeners() {
  for (const fn of authListeners) fn(currentUser);
}

export async function initAuth() {
  if (!isSupabaseConfigured()) return;

  // Check existing session
  const { data: { session } } = await supabase.auth.getSession();
  if (session?.user) {
    currentUser = session.user;
    notifyAuthListeners();
    // Don't block the initial render on hydration
    hydrateUserLibrary().catch(e => console.warn('hydrate failed', e));
  }

  // Listen for auth changes
  supabase.auth.onAuthStateChange((_event, session) => {
    const wasSignedIn = currentUser !== null;
    currentUser = session?.user || null;
    notifyAuthListeners();
    if (currentUser && !wasSignedIn) {
      hydrateUserLibrary().catch(e => console.warn('hydrate failed', e));
    } else if (!currentUser && wasSignedIn) {
      clearCloudStateOnSignOut();
    }
  });
}

export async function signInWithEmail(email) {
  if (!isSupabaseConfigured()) throw new Error('Supabase not configured');
  const { error } = await supabase.auth.signInWithOtp({ email });
  if (error) throw error;
}

export async function signInWithProvider(provider) {
  if (!isSupabaseConfigured()) throw new Error('Supabase not configured');
  const { error } = await supabase.auth.signInWithOAuth({
    provider,
    options: { redirectTo: window.location.origin },
  });
  if (error) throw error;
}

export async function signOut() {
  if (!isSupabaseConfigured()) return;
  await supabase.auth.signOut();
  currentUser = null;
  clearCloudStateOnSignOut();
  notifyAuthListeners();
}

export async function updateProfile(updates) {
  if (!isSupabaseConfigured() || !currentUser) return;
  const { error } = await supabase
    .from('profiles')
    .update(updates)
    .eq('id', currentUser.id);
  if (error) throw error;
}
